import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";

import { ConfluenceOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { experiments, useExperiment } from "@/utils/experiment";
import { FeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    FreeForTenUsersText,
    Headings,
    SubHeading,
    WelcomeBackHeading,
    WelcomeBackText
} from "../../../components";

export const ExistingUser = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    const experiment = useExperiment(
        experiments.confluenceContactAndCompanyExpandSiteActivation
    );

    const useContactExpandCohortLogic =
        experiment.type === "enrolled" && experiment.value;

    return (
        <FeatureExposed
            experimentKey="cfind-3467-signup-with-image-overlay"
            group="isTreatment"
        >
            <ConfluenceOverlayTemplate size="sm">
                <div
                    css={[
                        !team26VisualUpdates && headerOffsetForBlueBackgroundCss
                    ]}
                >
                    {team26VisualUpdates ? (
                        <Headings
                            main={<WelcomeBackText />}
                            sub={<FreeForTenUsersText />}
                        />
                    ) : (
                        <>
                            <WelcomeBackHeading />
                            <SubHeading>
                                <FormattedMessage
                                    id="BxpUiSignup.nameSite.cobrandedSubHeader"
                                    defaultMessage="It’s free for up to 10 users - no credit card needed."
                                />
                            </SubHeading>
                        </>
                    )}
                </div>
                <SiteActivation
                    useContactExpandCohortLogic={useContactExpandCohortLogic}
                />
            </ConfluenceOverlayTemplate>
        </FeatureExposed>
    );
};

const headerOffsetForBlueBackgroundCss = css({
    marginBlockStart: 54,
    [media.above.sm]: {
        marginBlockStart: 0
    }
});
